module.exports = __webpack_public_path__ + "static/cosypenguin-0a1f369bc304d13b973300a2af3cb757.jpeg";